import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

const labelVariants = cva(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
);

export interface LabelProps
  extends React.LabelHTMLAttributes<HTMLLabelElement>,
    VariantProps<typeof labelVariants> {
  /**
   * 필수 입력 필드임을 시각적으로 표시 (빨간 별표)
   * WCAG 3.3.2 (Labels or Instructions) 준수
   */
  required?: boolean;
}

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, required, children, ...props }, ref) => (
    <label
      ref={ref}
      className={cn(labelVariants(), className)}
      {...props}
    >
      {children}
      {required && (
        <span className="text-red-500 ml-0.5" aria-hidden="true" title="필수 입력">
          *
        </span>
      )}
    </label>
  )
);

Label.displayName = "Label";

export { Label };
